import ProjectView from "../project-view"
import ProjectViews from "../project-views"
import {ViewType} from "../../../gd/const/views/view-type"
import ApiProject from "../../../gd/api/project"

// const debug = "projectView_delete"
const debug = false

export default async function projectView_delete(projectViews: ProjectViews, view:ProjectView): Promise<void> {
    switch (view.systemType) {
        case ViewType.PROJECT_PAGE  :
            await ApiProject.deleteView(projectViews.project.id, view.id).promise()
            break

        default                     :
            await view.saveAppSettings(undefined, false)
            projectViews.remove(view.id)
            await projectViews.save()
    }
}